import React from 'react';
import Partners from '../components/Partners';

const AppLaunch = () => {
  return (
    <div className="bg-white">
      <div className="md:px-28 px-4 md:pt-6 pt-4 md:mb-10">
        <div>
          <h1 className="text-[10px] md:text-[36px] font-bold text-[#FDBD26] md:mb-4 mb-2">
            SPECIAL CALL
          </h1>
          <div>
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745527968/image_30_dss9w4.png"
              alt="Farmnet App"
              className="w-full h-full object-contain rounded-tr-md rounded-tl-md"
            />
            <div className='bg-[#F3F5F5] w-full md:h-[161px] shadow-[#979797] shadow-md rounded-br-md rounded-bl-md border-b-[3px] border-[#979797]'>
            </div>
          </div>
        </div>

        <div className='md:mt-10 mt-4'>
          <h1 className="text-[10px] md:text-[36px] font-bold text-[#FDBD26] md:mb-4 mb-2">
            FARMNET APP
          </h1>
          <div>
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745527968/image_31_jtlyf3.png"
              alt="Farmnet App"
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        <h1 className="text-[10px] md:mt-10 mt-5 md:text-[36px] font-bold text-[#FDBD26] md:mb-4 mb-2">
          LAUNCH
        </h1>
        <p className="text-[8px] md:text-[32px] font-bold">
          We are excited to invite you to a ground breaking event where we will unveil the FarmNet App—a mobile application set to revolutionize the future of agriculture as we know it.
        </p>
        <p className="mt-4 md:mt-8 mb-4 md:mb-8 text-[8px] font-bold text-[#155528] md:text-[32px]">
          Join us for this transformative moment in the industry!
        </p>

        <h1 className="text-[10px] md:mt-10 md:text-[36px] font-bold text-[#FDBD26] md:mb-4 mb-2">
          KEY NOTE SPEAKER
        </h1>
        <div className="relative">
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745528821/image_32_pibupp.png"
            alt="Farmnet App"
            className="w-full h-full object-contain"
          />

          {/* Overlay with blend mode */}
          <div className="absolute bottom-0 left-0 w-full h-[50px] md:h-[130px] flex items-center justify-between md:pl-16 pl-4 z-10 text-black">
            <div>
              <h2 className="text-[8px] md:text-[36px] font-bold">Professor PLO Lumumba</h2>
              <p className="text-[8px] md:text-[24px]">Empowering farmers through innovation</p>
            </div>

            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745528803/image_1718_lfgc5i.png"
              alt="QR"
              className="w-[50px] h-[50px] md:w-[120px] md:mt-2 md:h-[125px] object-contain"
            />
          </div>

          {/* Background layer with blend mode */}
          <div className="absolute bottom-0 left-0 w-full h-[50px] md:h-[120px] bg-[#D9D9D9] mix-blend-darken z-0" />
        </div>


        <p className="text-[8px] md:text-[32px] font-medium md:mt-10 md:mb-10">
          “Digitalizing agriculture serves as a transformative infrastructure, fostering collaboration and coordination throughout the entire agricultural value chain. This not only boosts production but also improves market access, paving the way for sustainable farming enterprises and long-term economic development of Africa."

        </p>

        <div className="relative md:p-8 p-4 bg-[#152C24] rounded-tr-md rounded-tl-md md:mt-16 mt-4">


          <div className="flex md:flex-row items-start justify-between w-full p-4 md:p-5 rounded-xl shadow-[0_4px_3px_0_rgba(0,0,0,0.4)] border-b-[3px] border-black">
            <div className="flex-1">
              <h1 className="text-[14px] md:text-[48px] text-[#FDBD26] font-bold">Date :</h1>
            </div>
            <div className="flex flex-col items-center justify-center leading-none md:mt-2 md:mt-0">
              <h1 className="text-[18px] md:text-[64px] text-white font-bold md:mb-0 mb-1">30.05.2025</h1>
              <h1 className="text-[14px] md:text-[32px] text-white font-bold md:mt-3">SATURDAY</h1>
            </div>
            <div className="flex-1" />
          </div>

          <div className="flex md:flex-row items-center justify-between w-full p-4 md:p-5 mt-4 md:mt-2 rounded-xl shadow-[0_4px_4px_0_rgba(0,0,0,0.4)] border-b-[3px] border-black">
            <div className="flex-1">
              <h1 className="text-[14px] md:text-[48px] text-[#FDBD26] font-bold">Time :</h1>
            </div>
            <div className="flex-1 flex justify-center items-center md:mt-0">
              <h1 className="text-[14px] md:text-[40px] text-white font-bold">AT 10AM</h1>
            </div>
            <div className="flex-1" />
          </div>
        </div>

        {/* Updated Image with Overlay */}
        <div className="relative w-full h-auto mt-0">
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744916705/image_12_fg6hzk.png"
            alt=".."
            className="w-full h-full object-contain"
          />

          {/* Bottom Overlay */}

        </div>

        <div className='mt-4 md:mt-6'>
          <h1 className='text-[10px] md:text-[24px] font-semibold'>
            <strong>LOCATION:</strong> 93Q5+48Q University of Namibia, Windhoek, Namibia
          </h1>
        </div>

        <div className="flex items-center justify-between md:gap-10 gap-4 bg-white rounded-xl md:mt-6">
          <div className="flex flex-col w-full md:w-auto">
           <a href='https://forms.gle/ZhkHaMXJffogzV3s9'>
           <button className="md:w-[647px] w-full h-[35px] md:h-[107px] bg-[#FDBD26] rounded-[10px] border-b-[3px] border-[#152C24] text-[14px] md:text-[48px] font-bold text-black shadow-sm">
              RSVP
            </button>
           </a>
            <h1 className='md:text-[20px] font-normal md:mt-4'>Click here to RSVP | <a className='underline' href='https://forms.gle/Kfi3MYZ1hi4zQSV6A'>  https://forms.gle/Kfi3MYZ1hi4zQSV6A</a></h1>
            <div className="md:mt-8 mt-4 mx-auto w-full md:w-[647px] text-center leading-tight">
              <p className="text-[#979797] text-[12px] md:text-[24px] font-extrabold">Kindly respond by</p>
              <p className="text-black text-[12px] md:text-[24px] font-extrabold">23rd May 2025</p>
            </div>
          </div>

          <div className="flex flex-col items-center md:items-end md:mt-0">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744916702/image_1700_d9ywb0.png"
              alt="QR Code"
              className="w-[100px] md:w-[270px] h-[100px] md:h-[270px] object-contain"
            />
            <p
              className="text-[10px] md:text-[28px] font-normal text-black md:text-left md:mt-2 mt-2"
              style={{ lineHeight: '1.20' }}
            >
              Scan this QR code to <br /> RSVP and view the <br /> Launch details on <br /> Farmnet website
            </p>
          </div>
        </div>

<Partners/>

        <div className='md:mt-12 flex justify-between items-center md:mb-10'>
          <h1 className='md:text-[32px] text-[12px]'>
            “Subscribe and get a free agri-<br />market trends report.”
          </h1>
          <button className="text-white w-[180px] md:w-[647px] h-[38px] md:h-[107px] bg-[#2E453D] rounded-[10px] border-b-[5px] border-[#FABC28] text-[14px] md:text-[48px] font-bold shadow-sm">
            Subscribe
          </button>
        </div>

        <div className='md:h-7 h-4'></div>
      </div>
    </div>
  );
};

export default AppLaunch;
